import { format } from 'date-fns';
import { IGerarRemessaBancoBrasil } from './types';
import { Arquivo } from '@/lib/Arquivo';
import { removerCaracterEspecial } from "@/utils/removerCaracterEspecial";
import { getNossoNumero } from './gerarDadosBoleto';

export function gerarRemessa({ dados }: IGerarRemessaBancoBrasil) {
  try {
    const {
      dadosBancario,
      beneficiario,
      boletos,
    } = dados.remessa;

    const arquivo = new Arquivo();
    const dataAtual = new Date();
    const data = format(dataAtual, 'ddMMyyyy');
    const hora = format(dataAtual, 'HHmmss');
    const remessa = `REM${dadosBancario.numeroRemessa.padStart(5, '0')}.CNAB`;

    // header do arquivo
    arquivo.add('001');
    arquivo.add('0000');
    arquivo.add('0');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add('2');
    arquivo.add(beneficiario.cnpj.padStart(14, '0'));
    arquivo.add(dadosBancario.convenio.padStart(9, '0'));
    arquivo.add('0014');
    arquivo.add(dadosBancario.carteira.padStart(2, '0'));
    arquivo.add(dadosBancario.variacao_carteira.padStart(3, '0'));
    arquivo.add('  ');
    arquivo.add('0');
    arquivo.add(`${dadosBancario.agencia}${dadosBancario.agenciaDigito}`.padStart(5, '0'));
    arquivo.add('00000');
    arquivo.add(`${dadosBancario.conta}${dadosBancario.contaDigito}`.padStart(8, '0'));
    arquivo.add(' ');
    arquivo.add(removerCaracterEspecial(beneficiario.nome).substring(0, 30).padEnd(30, ' '));
    arquivo.add('BANCO DO BRASIL S.A.'.padEnd(30, ' '));
    arquivo.add(' '.padEnd(10, ' '));
    arquivo.add('1');
    arquivo.add(data);
    arquivo.add(hora);
    arquivo.add(dadosBancario.numeroRemessa.padStart(6, '0'));
    arquivo.add('030');
    arquivo.add('00000');
    arquivo.add(' '.padEnd(40, ' '));
    arquivo.add(' '.padEnd(11, ' '));
    arquivo.add('CSP');
    arquivo.add('000');
    arquivo.add(' '.padEnd(12, ' '));
    arquivo.addLine();

    // header do lote
    arquivo.add('001');
    arquivo.add('0001');
    arquivo.add('1');
    arquivo.add('R');
    arquivo.add('01');
    arquivo.add('  ')
    arquivo.add('020');
    arquivo.add(' ');
    arquivo.add('2');
    arquivo.add(beneficiario.cnpj.padStart(15, '0'));
    arquivo.add(dadosBancario.convenio.padStart(9, '0'));
    arquivo.add('0014');
    arquivo.add(dadosBancario.carteira.padStart(2, '0'));
    arquivo.add(dadosBancario.variacao_carteira.padStart(3, '0'));
    arquivo.add('  ');
    arquivo.add('0');
    arquivo.add(`${dadosBancario.agencia}${dadosBancario.agenciaDigito}`.padStart(5, '0'));
    arquivo.add('00000');
    arquivo.add(`${dadosBancario.conta}${dadosBancario.contaDigito}`.padStart(8, '0'));
    arquivo.add(' ');
    arquivo.add(removerCaracterEspecial(beneficiario.nome).substring(0, 30).padEnd(30, ' '));
    arquivo.add(' '.padEnd(80, ' '));
    arquivo.add(dadosBancario.numeroRemessa.padStart(8, '0'));
    arquivo.add(data);
    arquivo.add('00000000');
    arquivo.add(' '.padEnd(33, ' '));
    arquivo.addLine();

    let sequencia = 0;
    let quantidadeRegistro = 0;
    let total = 0;

    for (const boleto of boletos) {
      const convenio = dadosBancario.convenio;
      let nosso_numero: string = '';

      if (convenio.length === 6) {
        switch (boleto.tipoDocumento) {
          case 'NFE': {
            nosso_numero = getNossoNumero(`${convenio}${boleto.id_boleto}2`);
            break;
          }
          case 'FAT': {
            nosso_numero = getNossoNumero(`${convenio}${boleto.id_boleto}4`);
            break;
          }
          case 'FIN': {
            nosso_numero = getNossoNumero(`${convenio}${boleto.id_boleto}5`);
            break;
          }
        }
      } else if (convenio.length === 7) {
        switch (boleto.tipoDocumento) {
          case 'NFE': {
            nosso_numero = `${convenio}${(boleto.id_boleto.toString() + '2').padStart(10, '0')}`;
            break;
          }
          case 'FAT': {
            nosso_numero = `${convenio}${(boleto.id_boleto.toString() + '4').padStart(10, '0')}`;
            break;
          }
          case 'FIN': {
            nosso_numero = `${convenio}${(boleto.id_boleto.toString() + '5').padStart(10, '0')}`;
            break;
          }
        }
      }

      const valorJurosDia = dadosBancario.jurosMes > 0
        ? Number(boleto.valor) * dadosBancario.jurosMes / 100 / 30
        : 0;

      const { pagador } = boleto;
      const tipoInscricao = pagador.pessoa === 'F' ? '1' : '2';

      const vencimento = format(new Date(boleto.vencimento), 'ddMMyyyy');
      total += Number(boleto.valor);

      const codigoDesconto = dadosBancario.descontoPagamento > 0 ? '2' : '0';
      const desconto = boleto.desconto > 0 
        ? boleto.desconto.toFixed(2)
        : dadosBancario.descontoPagamento > 0
          ? dadosBancario.descontoPagamento.toFixed(2)
          : '000000000000000';

      // PROTESTO/NEGATIVAÇÃO
      let protesto = '3';
      let diasProtesto = '00';
      let baixarDevolver = '1';
      let diasBaixa = '000';

      switch (dadosBancario.tipo_protesto) {
        case 'Nenhum':
          protesto = '3';
          diasProtesto = '00';
          baixarDevolver = '1';
          diasBaixa = '000';
          break;
        case 'Protestar':
          protesto = '1';
          diasProtesto = dadosBancario.diasProtesto.toString().padStart(2, '0');
          baixarDevolver = '2';
          diasBaixa = '060';
          break;
        case 'Negativar':
          protesto = '8';
          diasProtesto = dadosBancario.diasProtesto.toString().padStart(2, '0');
          baixarDevolver = '1';
          diasBaixa = '000';
          break;
        default:
          protesto = '3';
          diasProtesto = '00';
          baixarDevolver = '1';
          diasBaixa = '000';
          break;
      }

      // segmento P
      arquivo.add('001');
      arquivo.add('0001');
      arquivo.add('3');
      arquivo.add((++sequencia).toString().padStart(5, '0'));
      arquivo.add('P');
      arquivo.add(' ');
      arquivo.add('01');
      arquivo.add('0');
      arquivo.add(`${dadosBancario.agencia}${dadosBancario.agenciaDigito}`.padStart(5, '0'));
      arquivo.add('00000');
      arquivo.add(`${dadosBancario.conta}${dadosBancario.contaDigito}`.padStart(8, '0'));
      arquivo.add(' ');
      arquivo.add(nosso_numero.padEnd(20, ' '));
      arquivo.add('7'); // codigo carteira
      arquivo.add('1122');
      arquivo.add(`${boleto.numeroDocumento.padStart(6, '0')}-${boleto.parcela.toString().padStart(2, '0')}`.padEnd(15, ' '));
      arquivo.add(vencimento);
      arquivo.add(
        Number(boleto.valor).toFixed(2).replace('.', '').padStart(15, '0'),
      );
      arquivo.add('00000 ');
      arquivo.add('02'); // especie
      arquivo.add(boleto.aceite); // aceite
      arquivo.add(data);
      arquivo.add('1');
      arquivo.add('00000000');
      arquivo.add(valorJurosDia.toFixed(2).replace('.', '').padStart(15, '0'));
      arquivo.add(codigoDesconto);
      arquivo.add(vencimento);
      arquivo.add(desconto.replace('.', '').padStart(15, '0'));
      arquivo.add('000000000000000');
      arquivo.add('000000000000000');
      arquivo.add(boleto.identificacaoTitulo.padEnd(25, ' ')); // identificacao titulo, usar depois (retorno)
      arquivo.add(protesto);
      arquivo.add(diasProtesto);
      arquivo.add(baixarDevolver);
      arquivo.add(diasBaixa);
      arquivo.add('09');
      arquivo.add('0000000000');
      arquivo.add(' ');
      arquivo.addLine();

      pagador.endereco.logradouro = `${removerCaracterEspecial(pagador.endereco.logradouro)
          .substring(0, 32)
          .padEnd(32, ' ')}${pagador.endereco.numero.padEnd(8, ' ')}`;

      // segmento Q
      arquivo.add('001');
      arquivo.add('0001');
      arquivo.add('3');
      arquivo.add((++sequencia).toString().padStart(5, '0'));
      arquivo.add('Q');
      arquivo.add(' ');
      arquivo.add('01');
      arquivo.add(tipoInscricao);
      arquivo.add(pagador.cpfCnpj.padStart(15, '0'));
      arquivo.add(removerCaracterEspecial(pagador.nome).substring(0, 40).padEnd(40, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.logradouro).substring(0, 40).padEnd(40, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.bairro).substring(0, 15).padEnd(15, ' '));
      arquivo.add(pagador.endereco.cep);
      arquivo.add(removerCaracterEspecial(pagador.endereco.municipio).substring(0, 15).padEnd(15, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.uf).padEnd(2, ' '));
      arquivo.add('0');
      arquivo.add('000000000000000');
      arquivo.add(' '.padEnd(40, ' '));
      arquivo.add('000');
      arquivo.add(' '.padEnd(28, ' '));
      arquivo.addLine();

      dadosBancario.multaAtraso = Number(dadosBancario.multaAtraso || 0);
      if (dadosBancario.multaAtraso > 0) {
        const multa = dadosBancario.multaAtraso.toFixed(2);

        // segmento R
        arquivo.add('001');
        arquivo.add('0001');
        arquivo.add('3');
        arquivo.add((++sequencia).toString().padStart(5, '0'));
        arquivo.add('R');
        arquivo.add(' ');
        arquivo.add('01');
        arquivo.add('0');
        arquivo.add('00000000');
        arquivo.add('000000000000000');
        arquivo.add('0');
        arquivo.add('00000000');
        arquivo.add('000000000000000');
        arquivo.add('2');
        arquivo.add(vencimento);
        arquivo.add(multa.replace('.', '').padStart(15, '0'));
        arquivo.add(' '.padEnd(10, ' '));
        arquivo.add(' '.padEnd(40, ' '));
        arquivo.add(' '.padEnd(40, ' '));
        arquivo.add(' '.padEnd(20, ' '));
        arquivo.add('00000000');
        arquivo.add('000');
        arquivo.add('00000');
        arquivo.add(' ');
        arquivo.add('000000000000');
        arquivo.add('  ');
        arquivo.add('0');
        arquivo.add(' '.padEnd(9, ' '));
        arquivo.addLine();
      }

      quantidadeRegistro++;
    }

    // trailer do lote
    arquivo.add('001');
    arquivo.add('0001');
    arquivo.add('5');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add((sequencia + 2).toString().padStart(6, '0'));
    arquivo.add('000000');
    arquivo.add('00');
    arquivo.add('000000000000000');
    arquivo.add('000000000000000000000000000000000000000000000000000000000000000000000');
    arquivo.add(' '.padEnd(125, ' '));
    arquivo.addLine();

    // trailer do arquivo
    arquivo.add('001');
    arquivo.add('9999');
    arquivo.add('9');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add('000001');
    arquivo.add((sequencia + 4).toString().padStart(6, '0'));
    arquivo.add('000000');
    arquivo.add(' '.padEnd(205, ' '));
    arquivo.addLine();

    return {
      download: remessa,
      arquivo: arquivo.getArquivo(),
    };
  } catch (error) {
    console.log(error);
    return null;
  }
}
